/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.task.assignment.rpc.EligibleUsersRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getEligibleUsersRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.EligibleUsersRpc',
  rpcName: 'getEligibleUsers',
  auth: 'app',
  fingerprint: 'tMHmzO-78BgQokMhvXIEzJGYZJj_xslp'
};
export const searchEligibleUsersRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.EligibleUsersRpc',
  rpcName: 'searchEligibleUsers',
  auth: 'app',
  fingerprint: '4lBNInTkYhEySG8I9wLgI5GYZJj_xslp'
};
export const hasEligibleUsersRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.EligibleUsersRpc',
  rpcName: 'hasEligibleUsers',
  auth: 'app',
  fingerprint: 'KQixjoLiOQpt-0xrlm3lgJwP6LXzGzX8'
};